<template>
    <div class="container-fluid">
        <Breadcrumb title="Create PMTA Speed" v-bind:button-show="false" v-show="!id"></Breadcrumb>
        <Breadcrumb title="Edit PMTA Speed" v-bind:button-show="false" v-show="id"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="id">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card">
                    <div class="card-body">
                        <PmtaSpeedForm :id="id" @hidePreloader="hidePreloader"></PmtaSpeedForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import PmtaSpeedForm from './forms/PmtaSpeedForm';
    import Breadcrumb from '../components/Breadcrumb';

    export default {
        name: 'PmtaSpeed',
        props: ['id'],
        components: {
            Preloader, PmtaSpeedForm, Breadcrumb
        },
        data() {
            return {
                loading: false,
            }
        },
        mounted() {
            if (this.id) {
                this.loading = true;
            }
        },
        computed: {
        },
        methods: {
            hidePreloader(value) {
                this.loading = !value
            },
        }
    }
</script>

<style scoped>
</style>
